import React, { useEffect, useState } from 'react';
import { collection, addDoc, getDocs, query, where, deleteDoc, doc } from "firebase/firestore";
import { db } from '../../firebase/Firebase';

const EmailTab = () => {
  const [everyEmails, setEveryEmails] = useState([]);
  const [currentEveryEmail, setCurrentEveryEmail] = useState('');
  const orgId = localStorage.getItem('orgId');

  const fetchEmails = async (collectionName, setter) => {
    if (orgId) {
      const q = query(collection(db, collectionName), where("orgId", "==", orgId));
      const querySnapshot = await getDocs(q);
      const fetchedEmails = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setter(fetchedEmails);
    }
  };

  useEffect(() => {
    fetchEmails("Every", setEveryEmails);
  }, [orgId]);

  const addEmail = async (collectionName, email, setEmail, setCurrentEmail) => {
    if (email && orgId) {
      try {
        const docRef = await addDoc(collection(db, collectionName), {
          email: email,
          orgId: orgId
        });
        console.log("Document written with ID: ", docRef.id);
        fetchEmails(collectionName, setEmail);
      } catch (e) {
        console.error("Error adding document: ", e);
      }
      setCurrentEmail('');
    }
  };

  const deleteEmail = async (collectionName, emailId, setEmail) => {
    await deleteDoc(doc(db, collectionName, emailId));
    fetchEmails(collectionName, setEmail);
  };

  return (
    <div>
      <div>
        <label>Receive Emails for Every Delivery:</label>
        <div style={styles.emailContainer}>
          {everyEmails.map(({ id, email }) => (
            <span key={id} style={styles.emailTag}>
              {email}
              <button style={styles.removeButton} onClick={() => deleteEmail("Every", id, setEveryEmails)}>x</button>
            </span>
          ))}
          <input
            style={styles.hiddenInput}
            value={currentEveryEmail}
            onChange={(e) => setCurrentEveryEmail(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && addEmail("Every", currentEveryEmail, setEveryEmails, setCurrentEveryEmail)}
          />
        </div>
      </div>
    </div>
  );
};

const styles = {
  emailContainer: {
    height: '100px',
    width: '90%',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '5px',
    padding: '10px',
    marginBottom: '20px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  emailTag: {
    display: 'inline-block',
    padding: '5px',
    margin: '5px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    backgroundColor: '#FFC300',
    fontSize: '14px'
  },
  removeButton: {
    marginLeft: '5px',
    background: 'red',
    color: 'white',
    border: 'none',
    cursor: 'pointer'
  },
  hiddenInput: {
    border: 'none',
    outline: 'none',
    backgroundColor: 'transparent',
    width: '100%',
    height: '30px'
  }
};

export default EmailTab;
